import React from 'react';
import './Banner.css';
import macBook from '../../images/macbook.png';

const Banner = () => {
        return (
                <div className="container-fluid">
                        <div className="pt-5 banner row">
                                <div className="col-md-6 d-flex justify-content-center">
                                        <div className="w-75">
                                                <h1 className="text-white">Explore Your Next</h1>
                                                <h1 className="brand-color fw-bold text-decoration-underline">MacBook</h1>
                                                <p className="text-white pt-3">The MacBook is a brand of Macintosh notebook computers designed and marketed by Apple Inc. that use Apple's macOS operating system since 2006. It replaced the PowerBook and iBook brands during the Mac transition to Intel processors, announced in 2005.</p>
                                        </div>
                                </div>
                                <div className="col-md-5">
                                        <div className="p-5">
                                                <img className="img-fluid" src={macBook} alt="" />
                                        </div>
                                </div>
                        </div>
                </div>
        );
};

export default Banner;